import {
  ArrayFieldTemplateItemType,
  ArrayFieldTemplateProps,
} from '@rjsf/utils';
import React from 'react';
import ArrayFieldTitleTemplate from '../ArrayFieldTitleTemplate';
import ArrayFieldItemTemplate from '../ArrayFieldItemTemplate';
import Spacer from 'src/components/Layout/Spacer';

/**
 * Describes how arrays are rendered.
 * @see https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-templates/#arrayfieldtemplate
 * @param props ArrayFieldTemplateProps
 * @returns Renders an Array
 */
export const ArrayFieldTemplate = (props: ArrayFieldTemplateProps) => {
  const {
    idSchema,
    title,
    registry,
    onAddClick,
    uiSchema,
    schema,
    items,
    disabled,
  } = props;
  const { AddButton } = registry.templates.ButtonTemplates;

  return (
    <div>
      <ArrayFieldTitleTemplate
        idSchema={idSchema}
        title={title}
        schema={schema}
        uiSchema={uiSchema}
        registry={registry}
      />

      {items &&
        items.map(({ key, ...itemProps }: ArrayFieldTemplateItemType) => (
          <div key={key}>
            <ArrayFieldItemTemplate key={key} {...itemProps} />
            <Spacer height="0.75rem" />
          </div>
        ))}
      {props.canAdd && (
        <AddButton
          disabled={disabled}
          onClick={onAddClick}
          uiSchema={uiSchema}
          registry={registry}
        />
      )}
    </div>
  );
};
